module.exports = __webpack_public_path__ + "img/niunai3.97c89fd8.jpg";